export const formatWithDashes = (phoneNumber: string) => {
  const tempValue = phoneNumber.replace(/\D/g, '');
  if (tempValue.length === 11 && tempValue.match(/(^1)\d{10}/g))
    return `${tempValue.slice(0, 1)} (${tempValue.slice(
      1,
      4
    )})-${tempValue.slice(4, 7)}-${tempValue.slice(7)}`;

  return `${tempValue.slice(0, 3)}-${tempValue.slice(3, 6)}-${tempValue.slice(
    6
  )}`;
};

export const formatPhone = (input: string) => {
  if (input && typeof input === 'string' && input.length === 10) {
    return input.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2 $3');
  }
  if (input.length > 10) {
    return input.replace(
      /(1[- ]?)?\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})/,
      '($2)-$3-$4'
    );
  }
  return input;
};

export const ensureCountryCode = (input: string) => {
  // Be extra extra extra sure we're working with a string of numbers only
  const digits = String(input).replace(/\D/g, '');

  if (digits.length === 11 && digits.charAt(0) === '1') {
    return digits;
  }

  if (digits.length === 10 && digits.charAt(0) !== '1') {
    return `1${digits}`;
  }

  return '';
};

export const stripToLast10Digits = (input: string): string => {
  const digits = String(input).replace(/\D/g, '');
  return digits.slice(-10);
};
